import React from "react";
import ReactDOM from "react-dom";

const Modal = ({ open, children, onClose }) => {
  if (!open) return null;

  const portalRoot = document.getElementById("portal");

  return ReactDOM.createPortal(
    <>
      <div>
        {children}
      </div>
      <button onClick={onClose}>CLOSE MODEL</button>
    </>,
    portalRoot
  );
};

export default Modal;
